export * from './app-aside.component';



// WEBPACK FOOTER //
// /var/www/midac/midac-live/app/src/app/components/app-aside/index.ts